export default {"src":"/_next/static/media/verticalLogoWhiteIcon.1c2b3855.svg","height":416,"width":1000,"blurWidth":0,"blurHeight":0};